import store from '@/store';

function mostrarIdioma(s) {
  let mostrar = Array.isArray(s)
    ? s.find((e) => e.lang == store.state.langDefecto)
    : { text: s.es };
  return mostrar.text;
}
export default {
  getCategoriasSelect(state) {
    let devolver = [
      {
        text: 'Todos',
        value: null,
      },
    ];
    let cOrders = state.categoriasArray;
    cOrders = cOrders.sort((a, b) =>
      a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
    );
    for (let cat of cOrders) {
      let aux = {
        value: cat.id,
        text: cat.nombre ? mostrarIdioma(cat.nombre) : mostrarIdioma(cat.name),
      };
      devolver.push(aux);
    }
    return devolver;
  },
  getCategoriasOrder(state) {
    let objs = state.categoriasArray;
    return objs.sort((a, b) =>
      a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
    );
  },
};
